module.exports = __webpack_public_path__ + "ae10893df9ccf0580e795b149735fe4a.pdf";